<template>
  <div>
    <MeetingCard :expoMeetingCode="expoMeetingCode" />
    <el-row :gutter="10" class="mt-3">
      <el-col :span="12">
        <CommentsCard :expoMeetingCode="expoMeetingCode" recordType="M" />
      </el-col>
      <!-- <el-col :span="12">
        <DocCard :expoMeetingCode="expoMeetingCode" />
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
import MeetingCard from './components/meeting-card'
import CommentsCard from '../../detail/components/comments-card'
// import DocCard from '../../detail/components/doc-card'
export default {
  components: { MeetingCard, CommentsCard },
  props: { expoMeetingCode: { type: String, default: '' } },
}
</script>
